import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  error: {
    color: theme.palette.error.dark
  }
});

class RenderDropDownField extends React.Component {
  render() {
    const { input, label, options, meta: { touched, error }, classes, onChange, ...custom } = this.props;
    let value = [];
    if (input && input.value !== undefined) {
      value = input.value;
    } else if (custom && custom.value !== undefined) {
      value = custom.value;
    }
    
    if (custom.multiple && !Array.isArray(value)) {
      value = [].concat(value);
    }

    return (
      <React.Fragment>
        <TextField
          select
          onChange={onChange}
          value={value => Array.isArray(value) ? value : []}
          {...input}
          {...custom}
        >
          {options.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {error && touched && <FormHelperText className={classes.error}>This is required!</FormHelperText>}
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(RenderDropDownField);